import React, { useEffect, useState } from 'react';
import { ISize } from '@/version-types';
import { StageAPI } from '..';
import { useIdentity } from '../../core';
import { RenderStage } from '../../render';
import { useIsHideLayers, useScale } from '../hooks';

export const StageNode: React.FC<ISize> = React.memo(({ width, height }) => {
    const scale = useScale();
    const identity = useIdentity();
    const stageApi = StageAPI(identity);
    const [blur, setBlur] = useState(stageApi.blurStage.getBlur());
    useEffect(() => {
        return stageApi.blurStage.onBlur((e) => {
            // console.log('ot stage onBlur', e);
            setBlur(e);
        });
    }, []);

    const isHideLayers = useIsHideLayers();

    // console.log('ot stage', { blur, isHideLayers });

    return (
        <div
            className="l-scale l-layers-wrap"
            style={{
                width: `${width}px`,
                height: `${height}px`,
                transform: `translate3D(-50%, -50%, 0) scale(${scale})`,
                ...(blur
                    ? {
                          filter: `blur(${blur}px)`,
                      }
                    : {}),
                opacity: isHideLayers ? 0 : 1,
            }}
        >
            <RenderStage />
        </div>
    );
});
